import { useTranslation } from "react-i18next";

export const processPrompt = (
  newValue: string,
  prompt: string,
  language: string,
) => {
  // Extract existing course name and target audience
  const courseNameMatch = prompt.match(
    /(Ders Adı:|Course Name:)(.*?)(Hedef Kitle:|Target Audience:|Prompt:|$)/s,
  );
  const targetAudienceMatch = prompt.match(
    /(Hedef Kitle:|Target Audience:)(.*?)(Prompt:|$)/s,
  );

  const courseName = courseNameMatch ? courseNameMatch[2].trim() : "";
  const targetAudience = targetAudienceMatch
    ? targetAudienceMatch[2].trim()
    : "";

  const dersAdiPrefix = language === "tr" ? "Ders Adı:" : "Course Name:";
  const targetAudiencePrefix =
    language === "tr" ? "Hedef Kitle:" : "Target Audience:";
  const promptPrefix = language === "tr" ? "Prompt:" : "Prompt:";

  // Reconstruct with new prompt content
  const newPrompt = `${dersAdiPrefix} ${courseName} ${targetAudiencePrefix} ${targetAudience} ${promptPrefix} ${newValue}`;

  return newPrompt;
};
const CourseAndAudianceInput = ({
  input,
  setInput,
  labelClass,
}: {
  input: any;
  setInput: any;
  labelClass: string;
}) => {
  const { t, i18n } = useTranslation();
  return (
    <div className="grid grid-cols-2 gap-3">
      <div className="space-y-2 flex flex-col items-start">
        <label className={`inline-block text-sm font-medium ${labelClass}`}>
          {t("hooks.form.courseName")}
        </label>
        <input
          type="text"
          onChange={(e) => {
            let prompt = input.prompt || "";
            const courseName = e.target.value;
            const dersAdiPrefix =
              i18n.language === "tr" ? "Ders Adı:" : "Course Name:";

            // Extract existing parts
            const targetAudienceMatch = prompt.match(
              /(Hedef Kitle:|Target Audience:)(.*?)(Prompt:|$)/s,
            );
            const promptMatch = prompt.match(/(Prompt:)(.*?)$/s);

            const targetAudience = targetAudienceMatch
              ? targetAudienceMatch[2].trim()
              : "";
            const promptContent = promptMatch ? promptMatch[2].trim() : "";

            const targetAudiencePrefix =
              i18n.language === "tr" ? "Hedef Kitle:" : "Target Audience:";
            const promptPrefix = i18n.language === "tr" ? "Prompt:" : "Prompt:";

            // Reconstruct the prompt with all parts
            prompt = `${dersAdiPrefix} ${courseName} ${targetAudiencePrefix} ${targetAudience}`;
            if (promptContent) {
              prompt += ` ${promptPrefix} ${promptContent}`;
            }

            setInput({ ...input, prompt });
          }}
          className={`w-full rounded-xl border-2 border-gray-200 dark:border-gray-700 p-4 text-base focus:border-transparent dark:bg-gray-700/50 transition-all duration-200`}
        />
      </div>
      <div className="space-y-2 flex flex-col items-start">
        <label className={`inline-block text-sm font-medium ${labelClass}`}>
          {t("hooks.form.targetAudience")}
        </label>
        <input
          type="text"
          onChange={(e) => {
            let prompt = input.prompt || "";
            const targetAudience = e.target.value;

            // Extract existing parts
            const courseNameMatch = prompt.match(
              /(Ders Adı:|Course Name:)(.*?)(Hedef Kitle:|Target Audience:|Prompt:|$)/s,
            );
            const promptMatch = prompt.match(/(Prompt:)(.*?)$/s);

            const courseName = courseNameMatch ? courseNameMatch[2].trim() : "";
            const promptContent = promptMatch ? promptMatch[2].trim() : "";

            const dersAdiPrefix =
              i18n.language === "tr" ? "Ders Adı:" : "Course Name:";
            const targetAudiencePrefix =
              i18n.language === "tr" ? "Hedef Kitle:" : "Target Audience:";
            const promptPrefix = i18n.language === "tr" ? "Prompt:" : "Prompt:";

            // Reconstruct the prompt with all parts
            prompt = `${dersAdiPrefix} ${courseName} ${targetAudiencePrefix} ${targetAudience}`;
            if (promptContent) {
              prompt += ` ${promptPrefix} ${promptContent}`;
            }

            setInput({ ...input, prompt });
          }}
          className={`w-full rounded-xl border-2 border-gray-200 dark:border-gray-700 p-4 text-base focus:border-transparent dark:bg-gray-700/50 transition-all duration-200`}
        />
      </div>
    </div>
  );
};

export default CourseAndAudianceInput;
